if (document.getElementById('flag-dropdown li')) {
  document.getElementById('flag-dropdown li').addEventListener("click", function() {
    document.cookie = 'country_id=' + this.value;
    location.reload();

  });
}
